module.exports = __webpack_public_path__ + "img/2Y.0d281f89.png";